import Login from '../views/Login.vue';
import TwoFactorAuth from '../views/TwoFactorAuth.vue';
import TwoFactorRequired from '../views/TwoFactorRequired.vue';
import TwoFactorSuggested from '../views/TwoFactorSuggested.vue';
import Register from '../views/Register.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import App from '../views/App.vue';
import Dashboard from '../views/Dashboard.vue';
import Applications from '../views/Applications.vue';
import Application from '../views/Application.vue';
import Jobs from '../views/Jobs.vue';
import Branding from '../views/Branding.vue';
import Analytics from '../views/Analytics.vue';
import DataProtection from '../views/DataProtection.vue';
import Settings from '../views/Settings.vue';
import Job from '../views/Job.vue';
import EmailTemplates from '../views/settings/EmailTemplates.vue';
import InterviewTemplates from '../views/settings/InterviewTemplates.vue';
import Locations from '../views/settings/Locations.vue';
import CustomStyles from '../views/settings/CustomStyles.vue';
import Tracking from '../views/settings/Tracking.vue';
import Languages from '../views/settings/Languages.vue';
import Privacy from '../views/settings/Privacy.vue';
import Apikeys from '../views/settings/Apikeys.vue';
import GDPR from '../views/settings/GDPR.vue';
import Metadata from '../views/settings/Metadata.vue';
import Favicon from '../views/settings/Favicon.vue';
import Labels from '../views/settings/Labels.vue';
import Tags from '../views/settings/Tags.vue';
import Competences from '../views/settings/Competences.vue';
import CompanySettings from '../views/settings/CompanySettings.vue';
import Integrations from '../views/settings/Integrations.vue';
import Users from '../views/settings/Users.vue';
import NotFound404 from '../views/NotFound404.vue';
import Auth from '../views/Auth.vue';
import Campaigns from '../views/Campaigns.vue';
import Campaign from '../views/Campaign.vue';
import Interims from '../views/Interims.vue';
import Interim from '../views/Interim.vue';
import Personal from '../views/Personal.vue';
import AddJob from '../components/ui/AddJob.vue';
import AddCampaign from '../components/ui/AddCampaign.vue';
import CampaignsWrapper from '../components/CampaignsWrapper.vue';
import Roles from '../views/settings/Roles.vue';
import Documents from '../views/settings/Documents.vue';
import PricingPlans from '../views/settings/PricingPlans.vue';
import BillingDetails from '../views/settings/BillingDetails.vue';
import BillingHistory from '../views/settings/Invoices.vue';
import Import from "../views/Import.vue";
import JobChannels from '../views/settings/JobChannels.vue';
import FreeTrial from '../views/FreeTrial.vue';
import CompetenceTemplates from "../views/settings/CompetenceTemplates";
import JobReason from "../views/settings/JobReason";
import RejectReasons from "../views/settings/RejectReasons.vue";
import Interviews from "../views/Interviews.vue";
import FilterGroups from "../views/settings/FilterGroups.vue";
import MultiPosting from "../views/MultiPosting.vue";

export default [
    {
        path: '/',
        component: App,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '/',
                redirect: {name: 'dashboard'},
                name: 'dashboardredirect',
                component: Dashboard,
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                component: Dashboard,
            },
            {
                path: 'user',
                name: 'user',
                component: Personal,
            },
            {
                path: 'import',
                name: 'import',
                component: Import,
            },
            {
                path: 'applications',
                name: 'applications',
                component: Applications,
            },
            {
                path: 'applications/:id',
                name: 'application',
                component: Application,
            },
            {
                path: 'jobs',
                name: 'jobs',
                component: Jobs,
                props: (route) => ({filter: route.query.filter}),
            },
            {
                path: 'jobs/:id(\\d+)',
                name: 'job',
                component: Job,
                props: true,
            },
            {
                path: 'jobs/:id/edit',
                name: 'jobs.edit',
                component: AddJob,
                props: true,
            },
            {
                path: 'jobs/create',
                name: 'jobs.create',
                component: AddJob,
                props: (route) => ({filter: route.query.filter}),
            },
            {
                path: 'interviews',
                name: 'interviews',
                component: Interviews,
            },
            {
                path: 'campaigns',
                component: CampaignsWrapper,
                children: [
                    {
                        path: '',
                        name: 'campaigns',
                        component: Campaigns,
                    },
                    {
                        path: 'create',
                        name: 'campaigns.create',
                        component: AddCampaign,
                    },
                    {
                        path: ':id',
                        name: 'campaign',
                        component: Campaign,
                        props: true,
                    },
                ],
            },
            {
                path: 'multi-posting/:jobId?/:tab?',
                component: MultiPosting,
                name: 'multi-posting',
            },
            {
                path: 'employer-branding',
                name: 'branding',
                component: Branding,
            },
            {
                path: 'interims',
                name: 'interims',
                component: Interims,
            },
            {
                path: 'interims/:id',
                name: 'interim',
                component: Interim,
            },
            {
                path: 'data-protection',
                name: 'data-protection',
                component: DataProtection,
            },
            {
                path: 'analytics/:id',
                name: 'analyticsWithId',
                component: Analytics,
            },
            {
                path: 'analytics',
                name: 'analytics',
                component: Analytics,
            },
            {
                path: 'settings',
                component: Settings,
                children: [
                    {
                        path: '/',
                        name: 'settings.default',
                        redirect: {name: 'settings.company'},
                    },
                    {
                        path: 'email-templates',
                        name: 'settings.email-templates',
                        component: EmailTemplates,
                    },
                    {
                        path: 'interview-templates',
                        name: 'settings.interview-templates',
                        component: InterviewTemplates,
                    },
                    {
                        path: 'competence-templates',
                        name: 'settings.competence-templates',
                        component: CompetenceTemplates,
                    },
                    {
                        path: 'locations',
                        name: 'settings.locations',
                        component: Locations,
                    },
                    {
                        path: 'users',
                        name: 'settings.users',
                        component: Users,
                    },
                    {
                        path: 'roles',
                        name: 'settings.roles',
                        component: Roles,
                    },
                    {
                        path: 'documents',
                        name: 'settings.documents',
                        component: Documents,
                    },
                    {
                        path: 'languages',
                        name: 'settings.languages',
                        component: Languages,
                    },
                    {
                        path: 'company',
                        name: 'settings.company',
                        component: CompanySettings,
                    },
                    {
                        path: 'custom-css',
                        name: 'settings.custom-css',
                        component: CustomStyles,
                    },
                    {
                        path: 'tracking',
                        name: 'settings.tracking',
                        component: Tracking,
                    },
                    {
                        path: 'jobChannels',
                        name: 'settings.jobChannels',
                        component: JobChannels,
                    },
                    {
                        path: 'pricing-plans',
                        name: 'settings.pricing-plans',
                        component: PricingPlans,
                    },
                    {
                        path: 'billing-details',
                        name: 'settings.billing-details',
                        component: BillingDetails,
                    },
                    {
                        path: 'invoices',
                        name: 'settings.invoices',
                        component: BillingHistory,
                    },
                    {
                        path: 'api-keys',
                        name: 'settings.api-keys',
                        component: Apikeys,
                    },
                    {
                        path: 'integrations',
                        name: 'settings.integrations',
                        component: Integrations,
                    },
                    {
                        path: 'integrations/vdab',
                        name: 'settings.integrations.vdab',
                        component: Integrations,
                    },
                    {
                        path: 'integrations/officient',
                        name: 'settings.integrations.officient',
                        component: Integrations,
                    },
                    {
                        path: 'privacy',
                        name: 'settings.privacy',
                        component: Privacy,
                    },
                    {
                        path: 'metadata',
                        name: 'settings.metadata',
                        component: Metadata,
                    },
                    {
                        path: 'favicon',
                        name: 'settings.favicon',
                        component: Favicon,
                    },
                    {
                        path: 'labels',
                        name: 'settings.labels',
                        component: Labels,
                    },
                    {
                        path: 'tags',
                        name: 'settings.tags',
                        component: Tags,
                    },
                    {
                        path: 'competences',
                        name: 'settings.competences',
                        component: Competences,
                    },
                    {
                        path: 'reject-reasons',
                        name: 'settings.reject-reasons',
                        component: RejectReasons,
                    },
                    {
                        path: 'gdpr',
                        name: 'settings.gdpr',
                        component: GDPR,
                    },
                    {
                        path: 'vacancy/reasons',
                        name: 'settings.vacancy-reasons',
                        component: JobReason,
                    },
                    {
                        path: 'filter-groups',
                        name: 'settings.filter-groups',
                        component: FilterGroups,
                    }
                ],
            },
            {
                path: 'oops',
                name: 'oops',
                component: NotFound404,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'free-trial',
                name: 'free-trial',
                component: FreeTrial,
                meta: {
                    requiresAuth: true,
                    inSetup: true,
                },
            },
        ],
    },
    {
        path: '/',
        component: Auth,
        meta: {
            guest: true,
        },
        children: [
            {
                path: '/',
                redirect: {name: 'login'},
            },
            {
                path: 'login',
                name: 'login',
                component: Login,
            },
            {
                path: 'saml2/:uuid/login',
                name: 'saml2-login',
                meta: {
                    reload: true,
                }
            },
            {
                path: 'two-factor-authentication',
                name: 'two-factor-authentication',
                component: TwoFactorAuth,
            },
            {
                path: 'register',
                name: 'register',
                component: Register,
            },
            {
                path: 'forgot-password',
                name: 'forgot-password',
                component: ForgotPassword,
            },
            {
                path: 'reset-password',
                name: 'reset-password',
                component: ResetPassword,
                props: route => ({token: route.query.token, email: route.query.email}),
            },
            {
                path: "user-reset-password",
                name: "user-reset-password",
                component: ResetPassword,
                props: (route) => ({ token: route.query.token, email: route.query.email, isNewUser: true }),
            },
        ],
    },
    {
        path: '/',
        component: Auth,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: 'require-two-factor',
                name: 'require-two-factor',
                component: TwoFactorRequired,
                meta: {
                    twoFactorRequired: true,
                },
            },
            {
                path: 'suggest-two-factor',
                name: 'suggest-two-factor',
                component: TwoFactorSuggested,
                meta: {
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/:pathMatch(.*)',
        redirect: { name: 'oops' },
        meta: {
            requiresAuth: true,
        },
    },
];
